import React from 'react';
import { IconUIComponentProps, useIconStyle } from './Icon';

interface Props extends IconUIComponentProps {
  animated?: boolean;
}

export default function ({
  color,
  size,
  style,
  className,
  noFill,
  animated,
}: Props) {
  const styles = useIconStyle({ noFill });
  const classes = [styles.icon, className]
    .concat(animated ? 'animation-rotate' : '')
    .join(' ')
    .trim();
  return (
    <svg
      className={classes}
      color={color}
      fontSize={size}
      style={style}
      viewBox="0 0 24 19"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.35247 1.97295C8.11024 2.10524 7.80639 2.01656 7.67381 1.77488C7.54122 1.5332 7.6301 1.23005 7.87233 1.09776C11.3937 -0.825316 15.7659 -0.175775 18.5715 2.68575C20.5542 4.69281 21.4943 7.98916 21.1171 10.961L23.132 8.77504C23.3189 8.57225 23.6352 8.55903 23.8385 8.74553C24.0417 8.93202 24.055 9.24761 23.868 9.4504L20.573 13.0252C20.3862 13.2279 20.0718 13.2403 19.8696 13.0575C19.8616 13.0503 19.8538 13.0429 19.8463 13.0352L17.2904 10.4851C17.0952 10.2903 17.0952 9.97446 17.2904 9.77964C17.4857 9.58483 17.8023 9.58483 17.9976 9.77964L19.9617 11.7393C20.6462 8.85892 19.8201 5.3711 17.858 3.38477C15.3645 0.841591 11.4806 0.264602 8.35247 1.97295ZM15.9721 16.2516C16.2152 16.1208 16.5185 16.2114 16.6495 16.4539C16.7806 16.6965 16.6898 16.999 16.4467 17.1298C12.9446 19.0137 8.61685 18.3655 5.82236 15.5394C3.79251 13.4854 2.80264 10.1138 3.19781 7.12721L0.853504 9.46552C0.658215 9.66031 0.341632 9.66026 0.146397 9.46542C-0.0488376 9.27058 -0.0487934 8.95472 0.146496 8.75993L3.71703 5.19854C3.84829 5.05774 4.05544 4.99974 4.24892 5.06747C4.33892 5.09897 4.41419 5.15355 4.4704 5.22222L7.05295 8.02267C7.23992 8.22542 7.22676 8.54101 7.02355 8.72755C6.82033 8.9141 6.50402 8.90096 6.31705 8.69822L4.31833 6.53085C3.67778 9.3724 4.5605 12.8415 6.53434 14.8388C9.01673 17.3493 12.8612 17.925 15.9721 16.2516Z"
      />
    </svg>
  );
}
